import * as React from "react";
import Menu from "@mui/material/Menu";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { IconButton } from "@mui/material";
import {
  EditUserDataProps,
  EditUserProps,
  Participant,
} from "../../interfaces/interfaces";
import EditUserDialog from "./editUser/editUserDialog";
import SetDefaultPassword from "../../../../components/setDefaultPassword/setDefaultPassword";
import ChangeStatus from "./changeStatus";
import EditUser from "./editUser/editUser";
import AnonymizeUser from "./anonymizeUser";

const OptionMenu = ({
  participant,
}: {
  participant: Participant;
}): React.JSX.Element => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const [editUser, setEditUser] = React.useState<EditUserProps>({
    open: false,
    participant: {} as EditUserDataProps,
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void =>
    setAnchorEl(event.currentTarget);

  const handleClose = (): void => setAnchorEl(null);

  return (
    <React.Fragment>
      <IconButton
        sx={{ mr: 1 }}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {
          <MoreHorizOutlinedIcon
            sx={{
              transform: "rotate(90deg)",
            }}
          />
        }
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <ChangeStatus participant={participant} />
        <AnonymizeUser participant={participant} handleClose={handleClose} />
        <SetDefaultPassword
          userId={participant.participantId}
          disabled={participant.status === 1}
        />
        <EditUser participant={participant} setEditUser={setEditUser} />
      </Menu>

      {editUser.open && (
        <EditUserDialog editUser={editUser} setEditUser={setEditUser} />
      )}
    </React.Fragment>
  );
};

export default OptionMenu;
